module.exports = __webpack_public_path__ + "img/8_ward_300.f12e6d83.png";